import useApplePayFundingOptions from 'features/moveMoney/screens/ApplePay/hooks/useApplePayFundingOptions';
import { useTranslation } from 'react-i18next';
import WalletPayLimitInfo from 'shared/patterns/walletPay/screens/WalletPayLimitInfo/WalletPayLimitInfo';

const ApplePayLimitInfo = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'applePay',
  });

  const {
    data: {
      limitInformation: {
        dailyLimitInformation,
        monthlyLimitInformation,
        disclaimer,
      },
    },
  } = useApplePayFundingOptions('cache-only');

  return (
    <WalletPayLimitInfo
      title={translatedText('limits')}
      dailyLimitInformation={dailyLimitInformation}
      monthlyLimitInformation={monthlyLimitInformation}
      disclaimer={disclaimer}
    />
  );
};

export default ApplePayLimitInfo;
